import { styled } from "@mui/material";
import IconButton from "../IconButton";

export const StyledInlineNotificationWrapper = styled("div")`
  border-radius: ${(props) => props.theme.wsc.radius.m};  
  color: ${(props) => props.theme.wsc.palette.neutral[0]};
  background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
  padding: ${(props) => props.theme.wsc.spacing[2]};
  border: 0.071rem solid ${(props) => props.theme.wsc.palette.neutral[500]}};
`;

export const HeaderWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled("span")`
  font-size: ${(props) => props.theme.wsc.typography.header5.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.header5.fontWeight};
  margin-bottom: ${(props) => props.theme.wsc.spacing[2]};
`;

export const CloseButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.wsc.spacing[2]};
`;

export const Body = styled("span")`
  font-size: ${(props) => props.theme.wsc.typography.body1.fontSize};
`;
